import React from "react";
import { CommonModal } from "../../../AbstractElements";
import { useForm, useController } from "react-hook-form";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import Select from "react-select";
import { cancelTrip } from "../../../Services/Booking.service";
import { showAlert } from "../../../Services/Shared.service";
import CustomSelect from "../../../CommonElements/CustomSelect";
const CancelInvoiceCorrection = (props) => {
  const reasonData = props?.reasonData ? props.reasonData : [];
  const {
    register,
    handleSubmit,
    control,
    reset,
    resetField,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const reasonField = useController({ name: "reason", control }).field;

  const handleReasonSelect = (data) => {
    reasonField.onChange(data.value);
  };

  return (
    <CommonModal
      isOpen={props.Large}
      title={props.title}
      toggler={() => {
        reasonField.onChange("");
        props.LargeModaltoggle()
      }}
      size="md"
    >
      <Row className="cancel-booking">
        <Form onSubmit={handleSubmit(props.onReasonSubmit)}>
          <FormGroup className="row col-lg-12">
            <Label className="col-lg-12 col-form-label">Reason</Label>
            <Col lg="12">
              <CustomSelect
                className="service-select"
                classNamePrefix="select"
                isClearable={false}
                isSearchable={true}
                // defaultValue={}
                value={reasonData.find((element) => {
                  return element?.value?.id === reasonField?.value?.id;
                })}
                onChange={handleReasonSelect}
                placeholder="Select Reason"
                options={reasonData}
              />
            </Col>
          </FormGroup>
          <FormGroup className="row col-lg-12">
            <Label className="col-lg-12 col-form-label">Detailed Reason</Label>
            <Col lg="12">
              <textarea
                className="form-control"
                {...register("detailed_reason", {
                  required: {
                    value: false,
                  },
                })}
                type="text"
              />
            </Col>
          </FormGroup>
          <Row className="submit-booking">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={reasonField.value?.reason ? false : true}
            // onClick={() => onBookingSubmit()}
            >
              Submit
            </button>
          </Row>
        </Form>
      </Row>
    </CommonModal>
  );
};

export default CancelInvoiceCorrection;
